import { render, staticRenderFns } from "./DisplayProtocoloModal.vue?vue&type=template&id=a7f1509c&scoped=true"
import script from "./DisplayProtocoloModal.vue?vue&type=script&lang=js"
export * from "./DisplayProtocoloModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7f1509c",
  null
  
)

export default component.exports